import React from 'react';
import { WhiteboardContainer } from './whiteboard/WhiteboardContainer';
import { WhiteboardExternalProps } from '../types/whiteboardProps';
import { WhiteboardErrorBoundary } from './WhiteboardErrorBoundary';
import { useResponsiveMode } from '../hooks/useResponsiveMode';
import { useTestMetadataStore } from '../store/useTestMetadataStore';

interface WhiteboardLayoutProps {
  externalProps?: WhiteboardExternalProps;
}

const WhiteboardLayout: React.FC<WhiteboardLayoutProps> = ({ externalProps }) => {
  const { isMobileOrTablet, currentMode } = useResponsiveMode();
  const { getUIConfig } = useTestMetadataStore();
  
  // Get UI config from store
  const uiConfig = getUIConfig();
  
  // Merge external props with UI config from store
  const mergedExternalProps = React.useMemo(() => {
    if (!uiConfig && !externalProps) return undefined;
    
    if (!externalProps) {
      // Create minimal external props with just UI config
      return {
        uiConfig
      } as WhiteboardExternalProps;
    }
    
    return {
      ...externalProps,
      uiConfig: {
        ...uiConfig,
        ...externalProps?.uiConfig // External props take precedence
      }
    };
  }, [externalProps, uiConfig]);
  
  // Debug log
  React.useEffect(() => {
    console.log('WhiteboardLayout - isMobileOrTablet:', isMobileOrTablet);
    console.log('WhiteboardLayout - currentMode:', currentMode);
    console.log('WhiteboardLayout - UI Config from store:', uiConfig);
  }, [isMobileOrTablet, currentMode, uiConfig]);
  
  return (
    <WhiteboardErrorBoundary>
      <div className={'w-screen h-screen bg-gray-50 relative overflow-hidden'}>
        <div className={'absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-100'} />
        <div className={'relative z-10 w-full h-full'}>
          <WhiteboardContainer 
            externalProps={mergedExternalProps}
            isMobile={isMobileOrTablet}
            isPlayback={false}
            showToolbar={true}
          />
        </div>
      </div>
    </WhiteboardErrorBoundary>
  );
};

export default WhiteboardLayout;